/** Avatar button with the user's name, roles, settings and logout. */
import { LogOut, Settings } from 'lucide-react';
import { useNavigate } from 'react-router';
import type { Role } from '../../shared/api.js';
import { Avatar } from '../components/Avatar.js';
import { MenuButton } from '../components/Menu.js';
import { logout, useMe } from '../lib/session.js';
import styles from './AppShell.module.css';

export const ROLE_LABEL: Record<Role, string> = { admin: 'Beheerder', planner: 'Planner', viewer: 'Lezer' };

/** Highest role as a label ("Beheerder" for admins, ...; "Geen rol" without any). */
export function roleLabel(roles: readonly Role[]): string {
  if (roles.includes('admin')) return ROLE_LABEL.admin;
  if (roles.includes('planner')) return ROLE_LABEL.planner;
  if (roles.includes('viewer')) return ROLE_LABEL.viewer;
  return 'Geen rol';
}

export function UserMenu() {
  const me = useMe();
  const navigate = useNavigate();
  if (!me) return null;
  return (
    <MenuButton
      label={`Gebruikersmenu van ${me.user.name}`}
      buttonClassName={styles.userButton}
      header={
        <div className={styles.userHeader}>
          <strong className="truncate">{me.user.name}</strong>
          <span className="small muted truncate">{me.user.email}</span>
          <span className="badge">{roleLabel(me.user.roles)}</span>
        </div>
      }
      items={[
        { key: 'settings', label: 'Instellingen', icon: <Settings aria-hidden="true" />, onSelect: () => navigate('/instellingen') },
        { key: 'logout', label: 'Uitloggen', icon: <LogOut aria-hidden="true" />, onSelect: () => void logout() },
      ]}
    >
      <Avatar name={me.user.name} size={32} />
    </MenuButton>
  );
}
